import useDisableUserSelect from '@src/hooks/useDisableUserSelect';

function DisableUserSelect() {
  useDisableUserSelect();

  return null;
}

export default DisableUserSelect;
